import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { ref, get } from 'firebase/database';
import { db } from '../../config/firebase';
import CourseForm from './CourseForm';
import { WorkspacePageError, WorkspacePageLoader } from '../ui/Workspace';

const EditCourse = () => {
  const { id } = useParams();
  const [course, setCourse] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchCourse = async () => {
      try {
        const courseRef = ref(db, `courses/${id}`);
        const snapshot = await get(courseRef);

        if (snapshot.exists()) {
          setCourse({ id, ...snapshot.val() });
        } else {
          setError('Course not found');
        }
      } catch (err) {
        console.error('Error fetching course:', err);
        setError('Failed to load course');
      } finally {
        setLoading(false);
      }
    };

    fetchCourse();
  }, [id]);

  if (loading) {
    return <WorkspacePageLoader />;
  }

  if (error || !course) {
    return (
      <WorkspacePageError>
        <p>{error || 'Course not found'}</p>
      </WorkspacePageError>
    );
  }

  return <CourseForm courseId={id} initialData={course} />;
};

export default EditCourse;
